import React from 'react';
import PropTypes from 'prop-types';
import './custom-checkbox.css';

export default function CustomCheckbox({
  id,
  checked,
  onChange,
  label = '',
  disabled = false,
  color = '#36BB68',
  size = 'md', // sm | md | lg
  className = '',
  ...rest
}) {
  const inputId = id || `checkbox-${Math.random().toString(36).slice(2, 9)}`;

  return (
    <label
      htmlFor={inputId}
      className={`custom-checkbox ${size} ${disabled ? 'is-disabled' : ''} ${className}`}
      style={{ '--checkbox-color': color }}
    >
      <input
        id={inputId}
        type="checkbox"
        checked={checked}
        onChange={(e) => !disabled && onChange(e.target.checked, e)}
        disabled={disabled}
        {...rest}
      />
      <span className="checkbox-box" />
      {label && <span className="checkbox-label">{label}</span>}
    </label>
  );
}

CustomCheckbox.propTypes = {
  id: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  disabled: PropTypes.bool,
  color: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  className: PropTypes.string,
};
